const tipoMotivoTransferencia = [
  { text: 'Desmotivação com o treinador', value: 1 },
  { text: 'Problemas pessoais', value: 2 },
  { text: 'Trabalho', value: 3 },
  { text: 'Horário filho(s) escola', value: 4 },
  { text: 'Outro', value: 5 },
];

export default tipoMotivoTransferencia;
